import { useState } from "react";
import { toast } from "sonner";
import { Eye, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { CA, caErr } from "@/lib/clientAdmin";

// §80 Exact digest email a client will get next (server-rendered HTML in a sandboxed frame).
export const DigestPreview = ({ c }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    try { const { data } = await api.get(`${CA}/${c.id}/digest/preview`); setD(data); }
    catch (e) { toast.error(e.response?.status === 404 ? "Digest preview isn't live on the backend yet (spec §80)." : caErr(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size="sm" variant="outline" disabled={busy} onClick={open} className="h-8 border-[#27272A] text-zinc-200" data-testid="ca-digest-preview">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Eye className="h-3.5 w-3.5" />}Preview digest</Button>
      <Dialog open={!!d} onOpenChange={(o) => !o && setD(null)}>
        <DialogContent onOpenAutoFocus={(e) => { e.preventDefault(); e.currentTarget.focus(); }} className="flex max-h-[92vh] flex-col border-[#27272A] bg-[#0f0f12] sm:max-w-2xl" data-testid="ca-digest-dialog">
          <DialogTitle className="font-display text-lg text-zinc-50">Next weekly digest · {c.company}</DialogTitle>
          <div className="space-y-0.5 text-xs text-zinc-400" data-testid="ca-digest-meta">
            <p><span className="text-zinc-500">Subject:</span> <span className="text-zinc-200" data-testid="ca-digest-subject">{d?.subject}</span></p>
            {d?.sends_at && <p><span className="text-zinc-500">Sends:</span> {new Date(d.sends_at).toLocaleString([], { weekday: "long", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}</p>}
            {d?.recipients?.length > 0 && <p data-testid="ca-digest-recipients"><span className="text-zinc-500">To:</span> {d.recipients.join(", ")}</p>}
            {d?.quiet_week && <p className="text-amber-300" data-testid="ca-digest-quiet">Quiet week — they'll get the short note below.</p>}
          </div>
          <iframe title="Digest preview" sandbox="" srcDoc={d?.html || "<p style='font-family:sans-serif;color:#888'>No preview available.</p>"} className="min-h-[420px] w-full flex-1 rounded-xl border border-[#27272A] bg-white" data-testid="ca-digest-frame" />
        </DialogContent>
      </Dialog>
    </>
  );
};
